import React, { useState, useEffect, useRef } from "react";
import "./ImageCarousel.css";

const ImageCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [images, setImages] = useState([]);
    const [itemsPerView, setItemsPerView] = useState(3);
    const [selectedImage, setSelectedImage] = useState(null);
    const [tooltipVisibleId, setTooltipVisibleId] = useState(null);
    const [expandedImageId, setExpandedImageId] = useState(null);
    const tooltipTimeoutRef = useRef(null);

    // Generate image array
    useEffect(() => {
        const imageArray = [];
        for (let i = 1; i < 59; i++) {
            imageArray.push({
                id: i,
                original: `../assets/image/gallery/${i}.webp`,
                thumbnail: `../assets/image/gallery/${i}t.jpg`,
            });
        }
        setImages(imageArray);
    }, []);

    // Handle responsive itemsPerView
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setItemsPerView(1); // Mobile
            } else if (window.innerWidth < 1200) {
                setItemsPerView(2); // Tablet
            } else {
                setItemsPerView(3); // Desktop
            }
            setCurrentIndex(0); // Reset index on resize
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // detect touch devices
    // useEffect(() => {
    //     const touch = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    //     setIsTouch(!!touch);
    //     return () => {
    //         if (tooltipTimeoutRef.current) {
    //             clearTimeout(tooltipTimeoutRef.current);
    //         }
    //     };
    // }, []);

    const maxIndex = Math.max(0, images.length - itemsPerView);

    const handlePrev = () => {
        setCurrentIndex((prev) => Math.max(0, prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
    };

    const visibleImages = images.slice(currentIndex, currentIndex + itemsPerView);

    return (
        <div className="image-carousel-container">
            <h2 className="carousel-title">Gallery</h2>

            <div className="carousel-wrapper">
                {/* Left Button */}
                <button
                    className="carousel-button carousel-button-left"
                    onClick={handlePrev}
                    disabled={currentIndex === 0}
                    aria-label="Previous images"
                >
                    &#10094;
                </button>

                {/* Images Container */}
                <div className="carousel-images">
                    {visibleImages.map((image) => {
                        const handleImageTouchStart = () => {
                            // expand image + show tooltip on touch
                            setExpandedImageId(image.id);
                            setTooltipVisibleId(image.id);
                            if (tooltipTimeoutRef.current) {
                                clearTimeout(tooltipTimeoutRef.current);
                            }
                            tooltipTimeoutRef.current = setTimeout(() => {
                                setTooltipVisibleId(null);
                                setExpandedImageId(null);
                            }, 1200);
                        };

                        const handleImageClick = () => {
                            // single click/tap opens the lightbox
                            setSelectedImage(image);
                            setExpandedImageId(null);
                            setTooltipVisibleId(null);
                            if (tooltipTimeoutRef.current) {
                                clearTimeout(tooltipTimeoutRef.current);
                            }
                        };

                        return (
                            <div key={image.id} className="carousel-image-item">
                                <img
                                    src={image.original}
                                    alt={`Gallery ${image.id}`}
                                    className={`carousel-image ${expandedImageId === image.id ? 'mobile-expanded' : ''}`}
                                    onClick={handleImageClick}
                                    onTouchStart={handleImageTouchStart}
                                    style={{ cursor: "pointer" }}
                                />
                                <span className={`image-tooltip ${tooltipVisibleId === image.id ? 'visible' : ''}`} aria-hidden="true">Click to expand</span>
                            </div>
                        );
                    })}
                </div>

                {/* Right Button */}
                <button
                    className="carousel-button carousel-button-right"
                    onClick={handleNext}
                    disabled={currentIndex === maxIndex}
                    aria-label="Next images"
                >
                    &#10095;
                </button>
            </div>

            {/* Indicators */}
            <div className="carousel-indicators">
                {Array.from({ length: Math.ceil(images.length / itemsPerView) }).map(
                    (_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index ===
                                Math.floor(currentIndex / itemsPerView)
                                ? "active"
                                : ""
                                }`}
                            onClick={() => setCurrentIndex(index * itemsPerView)}
                            aria-label={`Go to group ${index + 1}`}
                        />
                    )
                )}
            </div>

            {/* Lightbox Modal */}
            {/* {selectedImage && (
                <div className="lightbox" onClick={() => setSelectedImage(null)}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="lightbox-close"
                            onClick={() => setSelectedImage(null)}
                            aria-label="Close lightbox"
                        >
                            ✕
                        </button>
                        <img
                            src={selectedImage.original}
                            alt={`Gallery ${selectedImage.id}`}
                            className="lightbox-image"
                        />
                    </div>
                </div>
            )} */}

            {selectedImage && (
                <div className="lightbox">
                    <div className="lightbox-overlay" onClick={() => setSelectedImage(null)} />
                    <div className="lightbox-content">
                        <button
                            className="lightbox-close"
                            onClick={() => setSelectedImage(null)}
                        >
                            ✕
                        </button>
                        <img
                            src={selectedImage.original}
                            alt={`Gallery ${selectedImage.id}`}
                            className="lightbox-image"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImageCarousel;
